var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.822,
    height: 14.698,
    viewBox: "0 0 14.822 14.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38886",
    "data-name": "Group 38886",
    transform: "translate(-1876.602 -260.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13322",
    "data-name": "Rectangle 13322",
    width: 13.835,
    height: 13.835,
    transform: "translate(1877 261)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_728966_edit_pen_pencil_writing_draw_icon",
    "data-name": "728966_edit_pen_pencil_writing_draw_icon",
    d: "M13.488,1.75,12.25.513a1.75,1.75,0,0,0-2.475,0L2.262,8.025A6.26,6.26,0,0,0,.875,10.137L0,14l3.862-.875a21.319,21.319,0,0,0,2.112-1.388l7.513-7.513A1.75,1.75,0,0,0,13.488,1.75ZM1.16,12.84l.568-2.51a.868.868,0,0,0,.018-.109c0-.005.006-.013.009-.018l1.979,1.979-.2.12Zm4.2-1.723a8.706,8.706,0,0,1-.86.592L2.23,9.442a7.857,7.857,0,0,1,.651-.8L8.538,2.987l2.475,2.475Zm7.511-7.511L11.631,4.843,9.157,2.369l1.238-1.237a.875.875,0,0,1,1.237,0l1.237,1.237a.875.875,0,0,1,0,1.237Z",
    transform: "translate(1877 261)",
    fill: "#4b96cd",
    stroke: "#4b96cd",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.2915d4cd7a4d0ea0706f49fb524bc2b9.svg";
export { ForwardRef as ReactComponent };